import {useEffect, useState} from 'react'
import cn from '../className.js'
import WindowFocusListener from './WindowFocusListener.js'
import {userSettingSelector} from '../../data/me.js'
import {useSelector} from '../../store.js'
import Icon from '../icons/Icon.js'

/**
 * FocusAlert component displays an alert when the browser tab is not focused.
 *
 * @param {Object} props
 * @param {String} [props.className] - Additional class names to apply to the alert container.
 * @param {React.ReactNode} props.children - The content to render when the alert is not shown.
 * @param {Function} [props.onFocusChange] - Callback function to notify when focus state changes.
 * @returns {React.ReactNode}
 */
export default function FocusAlert({className, children, onFocusChange}) {
  let [needsFocus, setNeedsFocus] = useState(false)
  const showFocusAlert = useSelector((state) =>
    userSettingSelector(state, {
      setting: 'show_focus_alert',
      defaultValue: true,
    }),
  )

  needsFocus = needsFocus && showFocusAlert

  useEffect(() => {
    if (!onFocusChange) {
      return
    }

    onFocusChange(needsFocus)
  }, [needsFocus])

  return (
    <>
      {showFocusAlert && (
        <WindowFocusListener
          onFocus={() => setNeedsFocus(false)}
          onBlur={() => setNeedsFocus(true)}
        />
      )}
      {needsFocus ? (
        <div className={cn`wrap--scan-alert ${className}`}>
          <div className="alert alert--warning-lt alert--lg align-center margin-bottom-0">
            <Icon
              name="exclamation-triangle"
              className="fs-04 op-50 lh-sm margin-bottom-5"
            />
            <p className="fs-01 lh-md margin-bottom-0">
              <strong>
                Barcode scans will not register unless Ordoro is the active tab
                in your browser
              </strong>
            </p>
          </div>
        </div>
      ) : (
        children
      )}
    </>
  )
}
